export const saveAs = (source: string, fileName: string) => {
  const is149Photos = source.includes('149.photos');

  const element = createElement('a', {
    href: source,
    ...(is149Photos ? { target: 'blank' } : { download: fileName })
  });

  element.style.display = 'none';

  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const openFilesDialog = ({ multiple, accept }: any = {}): Promise<FileList> => {
  const fileInput = createElement('input', { multiple, accept, type: 'file' }) as HTMLInputElement;

  return new Promise(resolve => {
    fileInput.addEventListener('change', () => resolve(fileInput.files), { once: true });

    fileInput.click();
  });
};

export const createElement = (
  tagName: string,
  attributes: Record<string, string> = {}
): HTMLElement | HTMLInputElement => {
  const element = document.createElement(tagName);

  Object.keys(attributes).forEach((key: string) => {
    element.setAttribute(key, attributes[key]);
  });

  return element;
};

export const bytesToMb = (bytes: number): number => {
  return bytes / 1024 / 1024;
};
